var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { attrs: { clas: "modal-title" } }, [
          _vm._v("Edit " + _vm._s(_vm.assetGroupData.groupName)),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          {
            staticClass: "form-wrapper",
            attrs: { validator: _vm.$v.assetGroup },
          },
          [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-100" },
                [
                  _c(
                    "form-group",
                    {
                      attrs: { label: "Asset Group Name*", name: "groupName" },
                    },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.assetGroup.groupName,
                          callback: function ($$v) {
                            _vm.$set(_vm.assetGroup, "groupName", $$v)
                          },
                          expression: "assetGroup.groupName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-100" },
                [
                  _vm.showTeamRegion
                    ? _c(
                        "form-group",
                        { attrs: { name: "teamRegion", label: "Team Region" } },
                        [
                          _c("team-region-options", {
                            attrs: {
                              selected: _vm.assetGroup.teamRegionId,
                              mode: "update",
                              "show-auto": false,
                            },
                            on: { selectedOption: _vm.handleTeamRegionChanged },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-50 icon-field" },
                [
                  _c(
                    "form-group",
                    { attrs: { label: "Vehicle / Asset Icon", name: "icon" } },
                    [
                      _c(
                        "md-select",
                        {
                          model: {
                            value: _vm.assetGroup.iconLabel,
                            callback: function ($$v) {
                              _vm.$set(_vm.assetGroup, "iconLabel", $$v)
                            },
                            expression: "assetGroup.iconLabel",
                          },
                        },
                        _vm._l(_vm.icons, function (icon, index) {
                          return _c(
                            "md-option",
                            { key: index, attrs: { value: icon.label } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(icon.label) +
                                  "\n                                "
                              ),
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "right" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      style: { color: _vm.getIconColour() },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(icon.name) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "material-icons display-icon",
                          style: { color: _vm.getIconColour() },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.assetGroup.icon) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-50 color-form-group" },
                [
                  _c(
                    "form-group",
                    { attrs: { name: "iconColour", label: "Colour" } },
                    [
                      _c("md-input", {
                        model: {
                          value: _vm.assetGroup.iconColour,
                          callback: function ($$v) {
                            _vm.$set(_vm.assetGroup, "iconColour", $$v)
                          },
                          expression: "assetGroup.iconColour",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.assetGroup.iconColour,
                        expression: "assetGroup.iconColour",
                      },
                    ],
                    staticClass: "color-picker",
                    attrs: { type: "color" },
                    domProps: { value: _vm.assetGroup.iconColour },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.assetGroup,
                          "iconColour",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-primary dialog-button",
            on: {
              click: function ($event) {
                return _vm.update()
              },
            },
          },
          [_vm._v("\n            Update\n        ")]
        ),
        _c(
          "md-button",
          {
            staticClass: "md-default dialog-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }